import Vue from 'vue'
import store from '../store'
import injector from 'vue-inject'

Vue.use(injector)

require('./api')
require('./status')

let api = injector.get('api')

class Account {
    /**
     * Save new user's account
     * @returns {Promise}
     */
    save (data) {
        return new Promise((resolve, reject) => {
            Vue.http.post(api.auth.registration, data).then(() => {
                store.commit('modals', {
                    modal: 'alert',
                    data: {
                        visible: true,
                        message: 'Registration complete. You can now log in.',
                        reload: false,
                    }
                })
                resolve()
            }, error => {
                switch (error.status) {
                    default:
                        this.errorMessage(error)
                        break
                }
                reject()
            })
        })
    }

    /**
     * Display error message
     * @param error
     */
    errorMessage (error) {
        store.commit('modals', {
            modal: 'alert',
            data: {
                visible: true,
                message: error.data.message[Object.keys(error.data.message)[0]],
                reload: false
            }
        })
    }
}

injector.service('account', Account);



// WEBPACK FOOTER //
// ./src/services/account.js